import { Link } from 'react-router-dom';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import styles from './BackorderBanner.module.css';

/**
 * Shown at the top of checkout while sublingual (suspension) products are on
 * back order.
 *
 * Deliberately not dismissible: it is the explanation for why Place Order is
 * disabled, so it has to stay visible for as long as the block applies.
 */
export default function BackorderBanner() {
    return (
        <div className={styles.banner} role="alert">
            <div className={styles.inner}>
                <WarningAmberIcon className={styles.icon} />
                <span className={styles.copy}>
                    Sublingual products are currently on back order. We can't fulfill these orders
                    at this time — please{' '}
                    <Link to="/programs" className={styles.link}>choose an injectable option</Link>
                    {' '}to continue.
                </span>
            </div>
        </div>
    );
}
